import { gql } from '@apollo/client';

export const REMOVE_DOCUMENT_TYPE_PROPERTY = gql`
  mutation removeDocumentTypeProperty($input: RemoveDocumentTypePropertyInput) {
    removeDocumentTypeProperty(input: $input) {
      commandId
    }
  }
`;
